import $ from 'jquery';
import templateData from '../utility/getTemplateData';
import appStore from '../stores/AppStore';

let _addShake = () => {

	$('.inputField  .money_input').addClass('animated shake');
	setTimeout(() => {
		$('.inputField  .money_input').removeClass('animated shake');
	}, 1000);
};

let updateDonation = (amount, redirecturl) => {

	let data = {
		token: templateData.token,
		amount: amount,
		currencyCode: templateData.donationCode,
		donationNote: appStore.getDonationNote() || ''
	}
	$('.spinneroverlay').show()
	$.post('/donate/update/donation', data, function(result) {
		// console.log('DATA result', result);
		window.location.href = redirecturl;
	}).fail(function() {
		// On mayFly update failure, redirecting to landing page
		// Mayfly token will be re-validated and will handle following cases
		// Case 1: Display generic error page for expired token
		// Case 2: Start new flow, if token is valid.
		let failureUrl = '/donate?token=' + templateData.token;
		window.location.href = failureUrl;

		// $('.spinneroverlay').hide();
		// $('.err_update_amount').show()
	})
};


/*
 * Handles for loaging any CAL event.
 */
let logCalEvent = (message) => {
	$.post('/donate/event/logger', {
		message: message
	})
};


let handleLogIn = () => {

	let donationAmount = appStore.getDonationAmount()

	if (donationAmount && parseFloat(donationAmount) >= 0.01) {

		updateDonation(donationAmount, '/donate/member?token=' + templateData.token);

	} else {
		_addShake();
	}
};


/*
 * Handles if token is reused to access donate app to make second payment.
 */
let handleTokenReuse = () => {
	let paymentStatus = templateData.paymentStatus || '';
	if (paymentStatus === 'complete') {
		window.location.href = '/donate/paymentComplete';
	}
};

let handleGuest = (scope) => {

	let donationAmount = appStore.getDonationAmount();

	if (donationAmount && parseFloat(donationAmount) >= 0.01) {

		scope.context.router.push('/donate/guest')

	} else {
		_addShake();
	}
};


let removeErrors = ($element) => {
	$element.parent().find('p.error').hide();
	$element.removeClass('error');
}


let serializeFormData = (obj) => {
	let o = {},
		a = obj.serializeArray();

	$.each(a, () => {
		if (o[this.name] !== undefined) {
			if (!o[this.name].push) {
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(this.value || '');
		} else {
			o[this.name] = this.value || '';
		}
	});
	return o;
};

let parseErrorResponse = (errors, dump) => {

	let messages = [],
		allErrorCodes = errors.details;

	for (let i in allErrorCodes) {
		let code = allErrorCodes[i].name,
			message = dump[code]
		if (message) {
			messages.push({
				key: i,
				value: message
			})
		}
	}

	if (messages.length === 0) {
		let message = dump.GENERIC_ERROR
		if (message) {
			messages.push({
				key: 0,
				value: message
			})
		}
	}
	return messages
}

let parseValErrResp = (errors, dump, GENERIC_ERROR) => {

	let messages = [],
		allErrorCodes = errors.errorData || [];
	for (let allError in allErrorCodes) {

		let code = allErrorCodes[allError].errorCode || allErrorCodes[allError].code,
			message = dump[code];

		if (message) {
			messages.push({
				key: allError,
				value: message
			})
		}
	}

	if (messages.length === 0) {
		let message = dump[GENERIC_ERROR]
		if (message) {
			messages.push({
				key: 0,
				value: message
			})
		}
	}
	return messages
}

let getErrFields = (errors) => {

	let allFields = [],
		allErrorCodes = errors.errorData || [];
	for (let allError in allErrorCodes) {
		allFields.push({
			key: allError,
			type: allErrorCodes[allError].code,
			fields: allErrorCodes[allError].fields
		})
	}

	if (allFields.length === 0) {
		allFields.push({
			key: 0,
			type: 'VALIDATION_ERROR'
		})
	}


	return allFields
}


module.exports = {
	addShake: _addShake,
	updateDonation: updateDonation,
	logCalEvent: logCalEvent,
	handleLogIn: handleLogIn,
	handleTokenReuse: handleTokenReuse,
	handleGuest: handleGuest,
	removeErrors: removeErrors,
	serializeFormData: serializeFormData,
	parseErrorResponse: parseErrorResponse,
	parseValErrResp: parseValErrResp,
	getErrFields: getErrFields
}



// WEBPACK FOOTER //
// ./utility/helper.js